import type { SelectionHandler } from "../../types";

import { SiteDetailHeader } from "./SiteDetailHeader";
import { SitesSelectionReportSummary } from "./SitesSelectionReportSummary";
import { sharedSiteSelectionResolver } from "./sharedSiteSelectionResolver";
import { siteSelectionResolver } from "./siteSelectionResolver";

export const SitesSelectionHandler: SelectionHandler = {
  SelectionHeader: SiteDetailHeader,
  selectionResolver: siteSelectionResolver,
  SelectionPrintableSummary: SitesSelectionReportSummary,
};

export const SharedSitesSelectionHandler: SelectionHandler = {
  SelectionHeader: SiteDetailHeader,
  selectionResolver: sharedSiteSelectionResolver,
  SelectionPrintableSummary: SitesSelectionReportSummary,
};
